import React, { Component } from "react";
import $ from 'jquery';

class InstructorTutorial extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			textNum: localStorage.getItem('displayTextNum'),
			mainTutorial: [
				{
					ArrayTutorial: [''],
					showNumbers: false,
				},
				{
					ArrayTutorial: ['Time left in the Class', 'Audio Settings', 'Video Settings', 'Chat', 'Mute/unmute all', 'Start/stop recording', 'Zoom your local video stream', 'Instructor Settings', 'Leave class' ],
					showNumbers: true,
				},
				{
					ArrayTutorial: ['See a list of all members in the class.', 'If a member who is not visible on the screen raises their hand, this icon appears on the screen.'],
					showNumbers: true,
				},
				{
					ArrayTutorial: ['Allow all members waiting into the Virtual Studio'],
					showNumbers: false,
				},
				{
					ArrayTutorial: ['View Workout Details.'],
					showNumbers: false,
				},
				{
					ArrayTutorial: ['Start workout script.'],
					showNumbers: false,
				},
				{
					ArrayTutorial: ['Stop workout script.', 'Pause workout script.', 'Next activity'],
					showNumbers: true,
				},
				{
					ArrayTutorial: ["When a member has a question, they will press the Hand Raised button on their screen. If that member's video stream is currently showing on your screen, you will see the Hand Raised at the top left corner. By clicking on the icon, instructor will unmute member."],
					showNumbers: false,
				},
				{
					ArrayTutorial: ["When member hide his stream for instructor this icon will be displayed on member stream"],
					showNumbers: false,
				},
				{
					ArrayTutorial: ['Once your conversation with the member is over, click on the icon to turn off the microphone and mute member'],
					showNumbers: false,
				}
			]				
		}
	}
	
	componentDidMount(){
		let indexInObject = localStorage.getItem('displayTextNum');
		indexInObject = parseInt(indexInObject) - 1;
		this.setState({
			textNum: localStorage.getItem('displayTextNum'),
		});
		
		let allHeight = $(window).height();
		let allWidth = $(window).width();
		
		$('.tutorial_back').css('height', allHeight+'px');
		$('.tutorial_back').css('width', allWidth+'px');
	}
	
	prevDefault = (e) => {
		e.preventDefault();
		e.stopPropagation();
	}
	
	render() {
		return (
			<div>
				<div className="instructorTutorial" onClick={this.prevDefault}>
					<div className="tutorialPointer" ></div>
					<div className="textForAllHolder" >
					{this.state.textNum > -1 &&
						<div>
							{this.state.mainTutorial[this.state.textNum]['ArrayTutorial'].map((item, i)=>
								<div className="instructorTutorialText" key={i} >
									{this.state.mainTutorial[this.state.textNum]['showNumbers'] &&
										<span className="marginTutorailNum">{i+1}.</span>
									}
									<span>{item}</span>
								</div>
							)}
						</div>
					}
					</div>
					<div className="btnsHolderTutorial" >
						<div className="oneBtnHold" >
							<div className="tutorialBtn" onClick={(e)=>{this.props.backTutorial(this.state.textNum, e)}} >Back</div>
						</div>
						<div className="oneBtnHold" >
							{this.state.textNum != 9 &&
								<div className="tutorialBtn" onClick={(e)=>{this.props.nextTutorial(this.state.textNum, e)}} >Next</div>
							}
							{this.state.textNum == 9 &&
								<div className="tutorialBtn" onClick={(e)=>{this.props.finishTutorial(this.state.textNum, e)}} >Finish</div>
							}
						</div>
					</div>
				</div>
			<div className="tutorial_back" ></div>	
		</div>
	)}
}
export default InstructorTutorial;
